import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import Loading from "../../../../components/Loader";
import classNames from "classnames";
import { handleGetRequest } from "../../../../services/GetTemplate";
import { handlePutRequest } from "../../../../services/PutTemplate";
import { endPoints } from "../../../../Config";

const EditViewFeature = ({ onHide, getFeatureList, featureDataId, isEditable }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const getFeatureById = async () => {
        setLoading(true);
        const response = await dispatch(handleGetRequest(endPoints.getFeatureById(featureDataId), false));
        if (response?.statusCode === 200) {
            const keyData = response?.data;
            console.log("keyData", keyData);
            formik.setFieldValue("featureId", keyData?.id);
            formik.setFieldValue("text", keyData?.text);
        }
        setLoading(false);
    };

    useEffect(() => {
        getFeatureById();
    }, [featureDataId]);

    const validationSchema = Yup.object().shape({
        text: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .required("This field is required"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            featureId: "",
            text: "",
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);

            let obj = {
                featureName: data?.text,
            };
            const response = await dispatch(handlePutRequest(obj, endPoints.updateFeature(data?.featureId), false, true));
            if (response?.statusCode === 200) {
                getFeatureList();
                onHide();
            }
            setLoadingBtn(false);
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            {loading ? <Loading /> : <></>}
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid pl-2 pr-2">
                    <div className="field col-12 md:col-6">
                        <label> Feature Name </label>
                        <span className="Label__Required">*</span>
                        <InputText placeholder="Enter Category Name" className={classNames({ "p-invalid": isFormFieldValid("text") }, "Input__Round")} id="text" name="text" maxLength={30} value={formik.values.text} onChange={formik.handleChange} type="text" disabled={!isEditable} />
                        {getFormErrorMessage("text")}
                    </div>

                    <div className="col-12 d-flex flex-row text-center mt-4 pb-2">
                        <Button className="Cancel-Button" label="Cancel" type="button" onClick={onHide} />
                        {isEditable === true && <Button className="Save-Button ml-2" label="Update" type="submit" loading={loadingBtn} />}
                    </div>
                </div>
            </form>
        </>
    );
};

export default EditViewFeature;
